export default __webpack_public_path__ + "static/media/ukrainegot-screenshot-03.7fa194fb.png";